import { compareAsc, compareDesc, parseISO } from "date-fns";

const isNullish = (
  value: string | null | undefined,
): value is "" | null | undefined => !value;

export const compareDatesAsc = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => {
  if (isNullish(a) && isNullish(b)) return 0;

  if (isNullish(a)) return 1;

  if (isNullish(b)) return -1;

  return compareAsc(parseISO(a), parseISO(b));
};

export const compareDatesDesc = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => {
  if (isNullish(a) && isNullish(b)) return 0;

  if (isNullish(a)) return 1;

  if (isNullish(b)) return -1;

  return compareDesc(parseISO(a), parseISO(b));
};
